import { render, staticRenderFns } from "./dataRate.vue?vue&type=template&id=56b95b1a&scoped=true&"
import script from "./dataRate.vue?vue&type=script&lang=js&"
export * from "./dataRate.vue?vue&type=script&lang=js&"
import style0 from "./dataRate.vue?vue&type=style&index=0&id=56b95b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b95b1a",
  null
  
)

export default component.exports